import AGREGAR_AUDITORIA_INFORME_OBSERVACION from '@/graphql/mutations/administracion/auditorias/observaciones/agregarAuditoriaInformeObservacion.gql';
import REMOVER_AUDITORIA_INFORME_OBSERVACION from '@/graphql/mutations/administracion/auditorias/observaciones/removerAuditoriaInformeObservacion.gql';
import ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION from '@/graphql/mutations/administracion/auditorias/observaciones/actualizarAuditoriaInformeObservacion.gql';
import AUDITORIA_INFORME_OBSERVACIONES from '@/graphql/querys/administracion/auditorias/auditoriaInformeObservaciones.gql';
import AGREGAR_AUDITORIA_INFORME_OBSERVACION_DETALLE from '@/graphql/mutations/administracion/auditorias/observaciones/detalles/agregarAuditoriaInformeObservacionDetalle.gql';
import REMOVER_AUDITORIA_INFORME_OBSERVACION_DETALLE from '@/graphql/mutations/administracion/auditorias/observaciones/detalles/removerAuditoriaInformeObservacionDetalle.gql';
import ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION_DETALLE from '@/graphql/mutations/administracion/auditorias/observaciones/detalles/actualizarAuditoriaInformeObservacionDetalle.gql';

export default {
  methods: {
    // AGREGAR OBSERVACION
    async mixAgregarAuditoriaInformeObservacion() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const idInforme = this.informe.id;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME_OBSERVACION,
          variables: { observacion: this.observacion },
          update: (store, { data: { agregarAuditoriaInformeObservacion } }) => {
            const query = {
              query: AUDITORIA_INFORME_OBSERVACIONES,
              variables: { idInforme },
            };
            const { auditoriaInformeObservaciones } = store.readQuery(query);
            const auditoriaInformeObservacionesCopia = auditoriaInformeObservaciones.slice();
            auditoriaInformeObservacionesCopia.push(agregarAuditoriaInformeObservacion);
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeObservaciones: auditoriaInformeObservacionesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // ELIMINAR OBSERVACION
    async mixEliminarAuditoriaInformeObservacion() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idAuditoriaInformeObservacion = this.observacion.id;
      const idInforme = this.observacion.idAuditoriaInforme;
      await this.$apollo
        .mutate({
          mutation: REMOVER_AUDITORIA_INFORME_OBSERVACION,
          variables: {
            id: idAuditoriaInformeObservacion,
          },
          update: (store) => {
            const query = {
              query: AUDITORIA_INFORME_OBSERVACIONES,
              variables: { idInforme },
            };
            const { auditoriaInformeObservaciones } = store.readQuery(query);
            const auditoriaInformeObservacionesCopia = auditoriaInformeObservaciones.slice();
            const index = auditoriaInformeObservacionesCopia.findIndex(
              ({ id }) => id === idAuditoriaInformeObservacion,
            );
            if (index !== -1) {
              auditoriaInformeObservacionesCopia.splice(index, 1);
            }
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeObservaciones: auditoriaInformeObservacionesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // ACTUALIZAR OBSERVACION
    async mixActualizarAuditoriaInformeObservacion() {
      const idInforme = this.observacionEditar.idAuditoriaInforme;
      const { id } = this.observacionEditar;
      const { observacion } = this;
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION,
          variables: {
            id,
            observacion,
          },
          update: (store, { data: { actualizarAuditoriaInformeObservacion } }) => {
            const query = {
              query: AUDITORIA_INFORME_OBSERVACIONES,
              variables: { idInforme },
            };
            const { auditoriaInformeObservaciones } = store.readQuery(query);
            const auditoriaInformeObservacionesCopia = auditoriaInformeObservaciones.slice();
            const index = auditoriaInformeObservacionesCopia.findIndex(
              (o) => o.id === actualizarAuditoriaInformeObservacion.id,
            );
            if (index !== -1) {
              auditoriaInformeObservacionesCopia.splice(
                index,
                1,
                actualizarAuditoriaInformeObservacion,
              );
            }
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeObservaciones: auditoriaInformeObservacionesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // AGREGAR DETALLE
    async mixAgregarAuditoriaInformeObservacionDetalle() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      this.observacionDetalle.idAuditoriaObservacion = this.observacion.id;
      if (this.observacion.idContrato && this.observacion.idContrato !== null) {
        this.observacionDetalle.idContrato = this.observacion.idContrato;
      }
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME_OBSERVACION_DETALLE,
          variables: {
            detalle: this.observacionDetalle,
          },
          update: (store, { data: { agregarAuditoriaInformeObservacionDetalle } }) => {
            const query = {
              query: AUDITORIA_INFORME_OBSERVACIONES,
              variables: { idInforme: this.informe.id },
            };
            const { auditoriaInformeObservaciones } = store.readQuery(query);
            const auditoriaInformeObservacionesCopia = auditoriaInformeObservaciones.slice();
            const observacion = auditoriaInformeObservacionesCopia.find(
              ({ id }) => id === this.observacion.id,
            );
            observacion.detalles.push(agregarAuditoriaInformeObservacionDetalle);
            const index = auditoriaInformeObservacionesCopia.findIndex(
              ({ id }) => id === observacion.id,
            );
            if (index !== -1) {
              auditoriaInformeObservacionesCopia.splice(index, 1, observacion);
            }
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeObservaciones: auditoriaInformeObservacionesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // ELIMINAR DETALLE
    async mixEliminarAuditoriaInformeObservacionDetalle() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idDetalleEliminar = this.detalle.id;
      await this.$apollo
        .mutate({
          mutation: REMOVER_AUDITORIA_INFORME_OBSERVACION_DETALLE,
          variables: {
            id: idDetalleEliminar,
          },
          update: async (store) => {
            const query = {
              query: AUDITORIA_INFORME_OBSERVACIONES,
              variables: {
                idInforme: this.observacion.idAuditoriaInforme,
              },
            };
            const { auditoriaInformeObservaciones } = store.readQuery(query);
            const auditoriaInformeObservacionesCopia = auditoriaInformeObservaciones.slice();
            const observacion = auditoriaInformeObservacionesCopia.find(
              ({ id }) => id === this.observacion.id,
            );
            let index = observacion.detalles.findIndex((d) => d.id === idDetalleEliminar);
            if (index !== -1) {
              observacion.detalles.splice(index, 1);
            }
            index = auditoriaInformeObservacionesCopia.findIndex(({ id }) => id === observacion.id);
            if (index !== -1) {
              auditoriaInformeObservacionesCopia.splice(index, 1, observacion);
            }
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeObservaciones: auditoriaInformeObservacionesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // ACTUALIZAR DETALLE
    async mixActualizarAuditoriaInformeObservacionDetalle() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const idObservacionDetalle = this.detalle.id;
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION_DETALLE,
          variables: {
            id: idObservacionDetalle,
            detalle: this.observacionDetalle,
          },
          update: (store, { data: { actualizarAuditoriaInformeObservacionDetalle } }) => {
            const query = {
              query: AUDITORIA_INFORME_OBSERVACIONES,
              variables: {
                idInforme: this.informe.id,
              },
            };
            const { auditoriaInformeObservaciones } = store.readQuery(query);
            const auditoriaInformeObservacionesCopia = auditoriaInformeObservaciones.slice();
            const observacion = auditoriaInformeObservacionesCopia.find(
              ({ id }) => id === this.observacion.id,
            );
            let index = observacion.detalles.findIndex(
              (d) => d.id === actualizarAuditoriaInformeObservacionDetalle.id,
            );
            if (index !== -1) {
              observacion.detalles.splice(index, 1, actualizarAuditoriaInformeObservacionDetalle);
            }
            index = auditoriaInformeObservacionesCopia.findIndex(({ id }) => id === observacion.id);
            if (index !== -1) {
              auditoriaInformeObservacionesCopia.splice(index, 1, observacion);
            }
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeObservaciones: auditoriaInformeObservacionesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // ACTUALIZAR COMENTARIO DETALLE
    async mixActualizarDetalleSoloComentario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const idObservacionDetalle = this.detalle.id;
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION_DETALLE,
          variables: {
            id: idObservacionDetalle,
            detalle: this.observacionDetalle,
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // ACTUALIZAR COMENTARIO OBSERVACION
    async mixActualizarObservacionSoloComentario() {
      const { id } = this.observacionEditar;
      const { observacion } = this;
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION,
          variables: {
            id,
            observacion,
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
